<template>
  <div class="discussView">
    <div class="bumenName">评价订单</div>
    <div class="table">
      <table class="order_tb">
        <colgroup>
          <col class="name_col">
          <col class="priority_col">
          <col class="teacher_col">
          <col class="pricing_col">
          <col class="pay_col">
          <col class="state_col">
          <col class="operate_col">
        </colgroup>
        <tbody>
          <tr class="tr-th">
            <td colspan="8">
              <!--<span class="number">订单编号：<a target="_blank">{{ orderData.orderNum }}</a></span>-->
              <span class="dealtime">创建时间：{{orderData.createTime}}</span></td>
          </tr>
          <tr class="hd">
            <td>稿件名称</td>
            <td>紧急</td>
            <td>选定老师</td>
            <td>定价</td>
            <td>实际付款</td>
            <td>订单状态</td>
            <td></td>
          </tr>
          <tr>
            <td><a :class="canDownContribution(orderData)?'down-load':''"
                   @mouseenter.once="downContribution(orderData)"
                   class="blue"
                   :href="orderData.realPath || 'javascript:;'"
                   target="_blank"
                   :disabled="!orderData.realPath"
            >{{orderData.contributionName}}</a>
            </td>
            <td>{{_options.pressingStatus[orderData.pressingStatus]}}</td>
            <td>{{orderData.dubboNum}}</td>
            <td class="red">{{orderData.appointPrice}}</td>
            <td class="red">{{orderData.realityPrice}}</td>
            <td>
              <i class="demand on" v-jq-tips="'已需求'"></i>
              <i class="demo" :class="{on:orderData.auditionIds}"
                 v-jq-tips="orderData.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"></i>
              <i class="pay" :class="{on:orderData.payId}" v-jq-tips="orderData.payId?'已经支付订单费用':'订单尚未支付'"></i>
              <i class="finished" :class="{on:orderData.productId || orderData.voiceLength}"
                 v-jq-tips="(orderData.productId || orderData.voiceLength)?'已经录制成品':'尚未录制成品'"></i>
              <i class="canceled" v-if="orderData.orderStatus == 10" v-jq-tips="'已取消'"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="dubbingGrade gradeWrap">
      <div class="hd clearfix">
        <div class="label">声音水平</div>
        <div class="grade"><i class="iconfont" v-for="item in 5" :class="[ item <= (dubbingGradeHover || dubbingGradeData) ? 'icon-shoucang':'icon-shoucang1',{'on':item == dubbingGradeData }]" @click="gradeFn(1,item)" @mouseenter="gradeEnter(1,item)" @mouseleave="dubbingGradeHover=0"></i></div>
        <div class="small" v-html="dubbingGradeHint ? dubbingGradeHint : performance[(dubbingGradeHover || dubbingGradeData)-1]"></div>
      </div>
      <div class="bd">声音成品是否满意?</div>
    </div>
    <div class="serviceGrade gradeWrap">
      <div class="hd clearfix">
        <div class="label">沟通能力</div>
        <div class="grade"><i class="iconfont" v-for="item in 5" :class="[ item <= (serviceGradeHover || serviceGradeData) ? 'icon-shoucang':'icon-shoucang1',{'on':item == serviceGradeData }]" @click="gradeFn(2,item)"  @mouseenter="gradeEnter(2,item)" @mouseleave="serviceGradeHover=0"></i></div>
        <div class="small" v-html="serviceGradeHint ? serviceGradeHint : performance[(serviceGradeHover || serviceGradeData)-1]"></div>
      </div>
      <div class="bd">服务过程双方沟通是否理解清晰?</div>
    </div>
    <div class="textarea">
      <div class="textareaHint" v-show="textareaHint">{{textareaHint}}</div>
      <textarea :disabled="!haveComments" v-model="textarea" placeholder="评论字数限制在5-200字符"></textarea>
      <div class="wordsNumber" :class="{'warn':textareaNum>200}">{{textareaNum}}/200字数</div>
    </div>
    <div class="submitWrap" v-if="haveComments"><a class="confirm" @click = "submitFn()">确定</a><router-link :to="{name:'OrderView'}" class="abandon">放弃</router-link></div>
  </div>
</template>

<script>
  import sdModal from '../components/sdModal.vue'
  import {mapState, mapActions, mapGetters} from 'vuex'
  import {util} from '../service/util'
  let API = util.api([
    'FINDMYORDER', // 查询订单
    'GETCONTRIBUTIONBYID', // id查询稿件
    'ADDTRANAPPRAISEINFO' // 添加订单评论
  ])

  export default {
    name: 'discuss-view',
    components: {
      sdModal
    },
    data () {
      return {
        haveComments: false,
        performance: ['不可接受', '一般般', '满意', '很好', '非常好'],
        dubbingGradeHover: 0,
        dubbingGradeData: 0,
        serviceGradeHover: 0,
        serviceGradeData: 0,
        dubbingGradeHint: '',
        serviceGradeHint: '',
        orderData: '',
        textareaHint: '',
        textarea: '',

        // 搜索条件参数
        searchOrder: {
          // 订单状态
          numberStr: 0,
          numberType: 2
        }
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.common.userInfo,
        _options: state => state.common.options
      }),
      textareaNum () {
        if (this.textarea.length <= 200) {
          this.textareaHint = ''
        }
        return this.textarea.length
      }
    },
    methods: {
      // grade click
      gradeFn (identifying, num) {
        // 1主播，2客服
        if (identifying === 1 && this.haveComments) {
          this.dubbingGradeData = num
          this.dubbingGradeHint = ''
        } else if (identifying === 2 && this.haveComments) {
          this.serviceGradeData = num
          this.serviceGradeHint = ''
        } else {}
      },
      // grade mouseenter
      gradeEnter (identifying, num) {
        // 1主播，2客服
        if (identifying === 1 && this.haveComments) {
          this.dubbingGradeHover = num
          this.dubbingGradeHint = ''
        } else if (identifying === 2 && this.haveComments) {
          this.serviceGradeHover = num
          this.serviceGradeHint = ''
        } else {}
      },
      // Search 订单
      doSearch () {
        // 取消显示合计
        this.searchOrder.numberStr = this.$route.query.id
        let param = {
          searchOrder: {
            ...this.searchOrder
          }
        }
        util.kAjax(API.FINDMYORDER, param, res => {
          this.orderData = res.data.datas[0]
          if (this.orderData.payId && this.orderData.dubbingGrade) {
            this.haveComments = false
            this.dubbingGradeData = this.orderData.dubbingGrade
            this.serviceGradeData = this.orderData.waiterGrade
            this.textarea = this.orderData.appraiseMessage || ''
          } else {
            this.haveComments = true
          }
        })
      },
      // 可下载稿件
      canDownContribution (item) {
        return item.contributionId
      },
      // 下载稿件
      downContribution (r) {
        if (!r.contributionId) {
          return
        }
        util.kAjax(API.GETCONTRIBUTIONBYID, {id: r.contributionId}, function (json) {
          // r.realPath = 'http://d.sd235.net/' + json.data.contributionServerPath
          r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath
        // window.open('http://d.sd235.net/' + json.data.contributionServerPath);
        }, function (err) {
          // util.confirm.error('错误','未找到该稿件！');
        }, true)
      },

      // 提交评论
      submitFn () {
        let verify = [false, false, true]
        let params = {
          orderId: this.orderData.id,
          dubbingGrade: this.dubbingGradeData,
          waiterGrade: this.serviceGradeData,
          appraiseMessage: this.textarea
        }

        if (params.dubbingGrade) {
          verify[0] = true
        } else {
          this.dubbingGradeHint = `<span style="color: red">请打分<span/>`
          verify[0] = false
        }
        if (params.waiterGrade) {
          verify[1] = true
        } else {
          this.serviceGradeHint = `<span style="color: red">请打分<span/>`
          verify[1] = false
        }
        if (params.appraiseMessage.length <= 200) {
          verify[2] = true
          this.textareaHint = ''
        } else {
          this.textareaHint = `不能超过200百字`
          verify[2] = false
        }
        if (verify.indexOf(false) === -1) {
          util.kAjax(API.ADDTRANAPPRAISEINFO, params, res => {
            this.doSearch()
          }, err => {
            util.confirm.error(err)
          })
        }
      }
    },
    watch: {
    },
    created () {
      this.doSearch()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DiscussView.vue?4fd25e78